module.exports = __webpack_public_path__ + "static/media/stjele.7999fe1e.m4a";